export const createRoute = (path, component, isProtected = false) => {
  return { path, component, isProtected };
};
